import { z } from 'zod';
/**
 * Versioned money wire shape (E-SF05).
 *
 * The platform guardrail: money crosses a boundary as
 * `{ amount_minor: string, currency, scale, v: 1 }` — minor-unit INTEGER as a
 * string (never a float, never a JS number that could lose precision), an ISO
 * currency, the scale (2 for USD cents), and a shape version so a later reader
 * can migrate.
 *
 * ── WHY A STRING, NOT A NUMBER ─────────────────────────────────────────────
 * A deposit is real money. Sending `40000` as a JSON number invites a float
 * somewhere downstream; sending `"40000"` keeps it an exact integer end to end.
 * The FE parses it with `BigInt`/decimal, never `parseFloat`. Deposit amounts
 * are decided server-side (Accounts' `DEPOSIT_CAP_MINOR` engine) — the wire only
 * carries them.
 *
 * This lives in the contract (not a backend Money VO import) because the contract
 * depends on nothing but zod — it is the shared edge, and the SPA cannot import a
 * server package.
 */
export const MoneyWireSchema = z.object({
    /** Minor-unit integer as a decimal string (e.g. "40000" = $400.00). */
    amount_minor: z.string().regex(/^-?\d+$/u, 'amount_minor must be an integer string'),
    /** ISO-4217 currency code. USD for the Texas retail path. */
    currency: z.string().length(3),
    /** Minor-unit scale: 2 for USD (cents). */
    scale: z.number().int().nonnegative(),
    /** Wire-shape version. Bump when the shape changes; readers branch on it. */
    v: z.literal(1),
});
//# sourceMappingURL=money.js.map